import { Box, Grid } from "@mui/material"
import { styled } from "@mui/material/styles"
import LoadingBox from "components/skeleton/LoadingBox/LoadingBox"
import LoadingTypography from "components/skeleton/LoadingTypography"
import { LoadingTextCell } from "./TextCell"

const StyledGrid = styled(Grid)({
  alignItems: "center",
  justifyContent: "space-between",
  "& .MuiGrid-item": {
    minWidth: 150
  }
})

const LoadingHeader = ({ noAnimate }) => {
  return (
    <Grid container direction="row" alignItems="flex-end" spacing={5} mt={2}>
      <Grid item md={9} sx={{ pt: "0 !important" }}>
        <Grid container direction="row" justifyContent="flex-start" alignItems="stretch">
          <Box marginRight={2}>
            <LoadingBox noAnimate={noAnimate} />
          </Box>
          <LoadingTypography variant="h2" noAnimate={noAnimate} />
        </Grid>

        <Box marginY={1} />
        <StyledGrid container direction="row" spacing={2}>
          <Grid item>
            <LoadingTextCell noAnimate={noAnimate} />
          </Grid>
          <Grid item>
            <LoadingTextCell noAnimate={noAnimate} />
          </Grid>
          <Grid item>
            <LoadingTextCell noAnimate={noAnimate} />
          </Grid>
          <Grid item>
            <LoadingTextCell noAnimate={noAnimate} />
          </Grid>
          <Grid item>
            <LoadingTextCell noAnimate={noAnimate} />
          </Grid>
        </StyledGrid>
      </Grid>
      <Grid item md={3} sx={{ pt: "0 !important" }}>
        <LoadingTypography variant="caption" noAnimate={noAnimate} />
        <LoadingTypography variant="bodySmall" noAnimate={noAnimate} />
        <LoadingTypography variant="bodySmall" noAnimate={noAnimate} />
        <LoadingTypography variant="bodySmall" noAnimate={noAnimate} width={"80%"} />
      </Grid>
    </Grid>
  )
}
export default LoadingHeader
